export default __webpack_public_path__ + "static/media/right-chevron.4cc9cf0c.svg";